"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SDK_VERSION = void 0;
// This is a magic string replaced by rollup
const SDK_VERSION = exports.SDK_VERSION = "8.55.0";